module.exports = "/desktop-app/assets/img/cc_default_avt.png?25830d8fc4aa4b353acee0e48884bf03";


//////////////////
// WEBPACK FOOTER
// ./foody/src/assets/common/static/icons/chat/cc_default_avt.png
// module id = /llD
// module chunks = 1